import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CupraBudgetOperationModel } from '../models/cuprabudgetoperation';

@Injectable({
  providedIn: 'root'
})

export class CupraBudgetOperationService {

  private pathAPI = environment.urlAPI;
  private controller = "CupraBudgetOperation/";

  constructor(private http: HttpClient) { }

  public post(idBudget:string, data: CupraBudgetOperationModel[]): Observable<CupraBudgetOperationModel[]> {
    return this.http.post<CupraBudgetOperationModel[]>(this.pathAPI + this.controller + idBudget, data);
  }
  
}
